import BlocksFavourites from "./BlocksFavourites.vue";

export default BlocksFavourites;
